module.exports = "/images/DemolitionRanch_aa84b4.jpg";